/**
 * Раздел «API» (`/integrations`): каналы, их проверки и активность, журнал сбоев.
 * Спека `docs/specs/2026-10-22-control-design.md`.
 */
import { apiFetch } from "@/lib/api";

export type State = "ok" | "warn" | "fail";

export type Check = {
  code: string;
  label: string;
  how: string;
  live: boolean;
  test: boolean;
  target: string;
  state: State;
  value: string;
  detail: string;
  checked_at: string;
  since: string;
};

export type Side = { last: string | null; today: number };

export type Channel = {
  code: string;
  label: string;
  how: string;
  /** Худшее из проверок канала; null — ещё не проверяли. */
  state: State | null;
  checked_at: string | null;
  activity: { in?: Side; out?: Side };
  problem: string | null;
  alerts: number;
  checks: Check[];
};

export type Alert = {
  id: number;
  code: string;
  channel: string;
  target: string;
  title: string;
  detail: string;
  opened_at: string;
  resolved_at: string | null;
  sent_at: string | null;
  resolved_sent_at: string | null;
  seen_at: string | null;
  seen_by: string | null;
};

export type Rule = { code: string; channel: string; label: string; how: string; live: boolean; repeat: number };

export type ControlReport = {
  now: string;
  /** Пишем ли владельцу в личку (флаг и боевая база). */
  send: boolean;
  owner: { tg: boolean; max: boolean };
  channels: Channel[];
  open: Alert[];
  rules: Rule[];
};

export type ScanResult = ControlReport & {
  scan: { checks: number; fail: number; opened: number; resolved: number; sent: number; errors: string[] };
};

export type TestResult = { channel: string; state: State; value: string; detail: string };

export const loadControl = () => apiFetch<ControlReport>("/api/control");
export const loadAlerts = (days = 30) => apiFetch<Alert[]>(`/api/control/alerts?days=${days}`);
export const runScan = () => apiFetch<ScanResult>("/api/control/scan", { method: "POST" });
export const runTestSend = () => apiFetch<TestResult[]>("/api/control/test-send", { method: "POST" });
export const ackAlerts = (ids: number[]) =>
  apiFetch<{ seen: number }>("/api/control/alerts/ack", { method: "POST", body: JSON.stringify({ ids }) });
